export const trustBadges = {
  neasc: "NEASC Accredited",
  xunta: "Authorized by Xunta de Galicia",
  trilingual: "English 40-50% | ES | GL",
  ages: "3-12 years · Small ratios"
};
